import instance from "../axios";

export const getAll = async ({ dateFrom, dateTo, smdID, duration, page, pageSize, visibility } = {}) => {
  const params = {};

  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  if (smdID) params.smdID = smdID;
  if (duration) params.duration = duration;
  if (page) params.page = page;
  if (pageSize) params.pageSize = pageSize;
  if (visibility) params.visibility = visibility

  const response = await instance.get(`visitations`, { params });
  return response.data;
};
export const getDurationSummary = async (params) => {
  const query = new URLSearchParams(params).toString();
  const response = await instance.get(`visitations/duration?${query}`);
  return response.data;
};

export const getDetails = async (id) => {
  const response = await instance.get(`visitations/` + id);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`visitations`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`visitations`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`visitations/` + id);
  return response;
};
